import moment from "moment";
import { Plus, Trash2 } from "lucide-react";
import Button from "../../components/Button";
import FormField from "../../components/FormField";
import IconButton from "../../components/IconButton";
import TextInput from "../../components/TextInput";

const valueOrDash = (value) => value === undefined || value === null || value === "" ? "Not recorded" : value;
const statusLabel = (value) => Number(value) === 1 ? "Yes" : Number(value) === 0 ? "N/A" : "Not recorded";
const formatDate = (value) => value && moment.utc(value).isValid() ? moment.utc(value).format("D MMM YYYY, HH:mm") : valueOrDash(value);
const errorFor = (errors, path) => errors?.[path]?.[0] || "";

const ReadOnlyGrid = ({ items }) => (
  <dl className="wsm-record-grid">
    {items.map(({ label, value }) => <div key={label}><dt>{label}</dt><dd>{valueOrDash(value)}</dd></div>)}
  </dl>
);

const EngineeringTrains = (props) => {
  const formData = props.formData || {};
  const locationData = props.locationData || {};
  const movements = Array.isArray(formData.movements) && formData.movements.length > 0 ? formData.movements : [{}];

  return (
    <div className="wsm-engineering-trains">
      <section className="wsm-record-section">
        <div className="wsm-record-section__heading"><h4>Pack references</h4><p>Inherited from the pack and completed record.</p></div>
        <ReadOnlyGrid items={[
          { label: "WON item number", value: locationData.won_item_no },
          { label: "Possession number", value: locationData.possession_no },
          { label: "Worksite ID", value: formData.worksite_id || locationData.worksite_id },
        ]} />
      </section>

      <section className="wsm-pack-form-section">
        <div className="wsm-pack-form-section__heading">
          <div><h3>Train and OTM movements</h3><p>Add each engineering train, OTP or OTM expected to enter the worksite.</p></div>
          <Button icon={Plus} onClick={() => props.handleAddFormRow("forms.eng_train.movements", {})} size="compact" type="button" variant="outline">Add movement</Button>
        </div>
        <div className="wsm-pack-form-section__entries">
          {movements.map((movement, index) => (
            <article className="wsm-pack-form-section__entry" key={`engineering-movement-${index}`}>
              <div className="wsm-pack-form-section__entry-heading">
                <h4>Movement {index + 1}</h4>
                <IconButton aria-label={`Remove movement ${index + 1}`} disabled={index === 0} icon={Trash2} onClick={() => props.handleRemoveFormRow("forms.eng_train.movements", index, true, "train or OTM movement")} size="compact" variant="destructive" />
              </div>
              <FormField error={errorFor(props.errors, `data.forms.eng_train.movements.${index}.headcode`)} id={`engineering-headcode-${index}`} label="Headcode or OTP/OTM unique number">
                {(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`forms.eng_train.movements.${index}.headcode`, event.target.value)} value={movement.headcode || ""} />}
              </FormField>
              <ReadOnlyGrid items={[
                { label: "Entered worksite", value: formatDate(movement.entered_worksite) },
                { label: "Line arrived on", value: movement.line_arrived_on },
                { label: "Departed worksite", value: formatDate(movement.departed_worksite) },
                { label: "Line departed on", value: movement.line_departed_on },
                { label: "Movement authorised", value: statusLabel(movement.is_movement_authorised) },
                { label: "Movement completed", value: statusLabel(movement.is_movement_completed) },
              ]} />
            </article>
          ))}
        </div>
      </section>

      <section className="wsm-record-section">
        <div className="wsm-record-section__heading"><h4>Worksite clearance</h4><p>Completed as the worksite is inspected and cleared.</p></div>
        <ReadOnlyGrid items={[
          { label: "Sweep/inspection commenced", value: formatDate(formData.worksite_sweep_commenced) },
          { label: "Sweep/inspection complete", value: formatDate(formData.worksite_sweep_complete) },
          { label: "Confirmed clear by", value: formData.worksite_cleared_by },
          { label: "Vehicles confirmed clear", value: formatDate(formData.worksite_vehicles_clear) },
          { label: "Trains/OTMs confirmed clear", value: formatDate(formData.worksite_trains_clear) },
        ]} />
      </section>
    </div>
  );
};

export default EngineeringTrains;